<template lang='pug'>
//- 功能使用流程
div(:class='$style[`cc-popbox-feature`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='feature === `se`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 記錄副作用
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/sideeffect/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/sideeffect/step2.webp`' width='100%')
        figure(:class='[$style[`cc-feature-wrap-grid-img`], $style[`single-row`]]')
          img(:src='`${STATIC_URL}images/news/sideeffect/step3.webp`' width='100%')

  div(v-if='feature === `translator`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 診斷報告解說 
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/translator/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/translator/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/translator/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/translator/step4.webp`' width='100%')

  div(v-if='feature === `consult`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 線上諮詢專家 
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/consult/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/consult/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/consult/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/consult/step4.webp`' width='100%')

  div(v-if='feature === `ai`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold QA問答庫
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/ai/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/ai/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/ai/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/ai/step4.webp`' width='100%')

  div(v-if='feature === `shop`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 升級VIP/保健品商店
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step4.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step5.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/shop/step6.webp`' width='100%')

  div(v-if='feature === `notify`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 改善建議與通知
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/notify/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/notify/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/notify/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/notify/step4.webp`' width='100%')

  div(v-if='feature === `resume`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 癌友故事卡
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step4.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step5.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step6.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step7.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/resume/step8.webp`' width='100%')

  div(v-if='feature === `qa`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 癌症討論板
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/qa/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/qa/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/qa/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/qa/step4.webp`' width='100%')

  div(v-if='feature === `scoop`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 精選文章
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/scoop/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/scoop/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/scoop/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/scoop/step4.webp`' width='100%')

  div(v-if='feature === `help`' :class='$style[`cc-popbox-feature-type`]')
    div(:class='$style[`cc-popbox-feature-title`]')
      span.font-bold 公益資源
      span.font-bold.font-doctor-theme.no-wrap 教
      span.font-bold.font-normal-theme.no-wrap 學
    div(:class='$style[`cc-feature-wrap`]')
      div(:class='$style[`cc-feature-wrap-grid`]')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/help/step1.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/help/step2.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/help/step3.webp`' width='100%')
        figure(:class='$style[`cc-feature-wrap-grid-img`]')
          img(:src='`${STATIC_URL}images/news/help/step4.webp`' width='100%')

  div(:class='$style[`cc-content-feature-controller`]')
    button.btn-extra.font-medium(
      aria-label='知道了'
      tabindex='0'
      :class='$style[`cc-feature-controller-btn`]'
      @click='handleClosePopBox') 知道了

</template>

<script>
import { mapMutations } from 'vuex';
import IconCcoin from '../../icon/Ccoin';

export default {
  props: {
    feature: {
      type: String,
      default: '',
    },
  },

  components: {
    IconCcoin,
  },

  // data() {
  //   return {
  //   };
  // },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //   }),
  // },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popHowToUseFeature.scss';
</style>
